import VerifyOutPurchaseReturn from "../../../../components/@documents/purchase_returns/VerifyOutPurchaseReturn";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function PurchaseReturnVerifyOutPage() {

    return (
        <VerifyOutPurchaseReturn 
            routeType={routeTypes.workstation}
        />
    )
}